import {
  Box,
  Button,
  Card,
  CardHeader,
  Container,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  LinearProgress,
  LinearProgressProps,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import React, { ChangeEvent, Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import GetAppIcon from '@mui/icons-material/GetApp';
import styled from '@emotion/styled';
import { useForm } from 'react-hook-form';
import { withStyles } from '@mui/styles';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import moment from 'moment';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { getProjectTotalAllocation } from 'src/services/projectService';
import { TableColumnCell } from 'src/components/TableColumnCell';

interface Filters {
  type: string;
  po_status: string;
  status: string;
  cat: string;
}

const applyFilters = (employees: any[], filters: Filters): any[] => {
  return employees.filter((employeeStatus) => {
    let matches = true;
    // if (filters.status && employeeStatus.status !== filters.status) {
    //   matches = false;
    // }
    return matches;
  });
};

const applyPagination = (
  employees: any[],
  page: number,
  limit: number
): any[] => {
  return employees.slice(page * limit, page * limit + limit);
};

const TotalResourceAllocation = () => {
  const navigate = useNavigate();
  const [toggleFilter, setToggleFilter] = useState(false);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [filters, setFilters] = useState<Filters>({
    type: null,
    po_status: null,
    status: null,
    cat: null
  });

  var initalList: any[] = [];
  const [employees, setEmployees] = useState(initalList);

  const getEmployeeData = () => {
    getProjectTotalAllocation().then((res) => {
      setEmployees((res.data as any[]) || []);
    });
  };

  useEffect(() => {
    getEmployeeData();
  }, []);

  let initialProjectFilterValues = {
    name: null,
    project: null,
    role: null,
    startDate: null,
    endDate: null
  } as any;

  const { register, handleSubmit, reset, getValues, setValue } = useForm<any>({
    defaultValues: initialProjectFilterValues
  });
  const [isDisabled, setIsDisabled] = useState(false);

  const filteredEmployees = applyFilters(employees, filters);

  const paginatedEmployees = applyPagination(filteredEmployees, page, limit);

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  const [searchKeywords, setSearchKeywords] = useState('');

  //when user started to type the name in the text field
  const nameChange = (event) => {
    setSearchKeywords(event.target.value);
  };

  const searchGroupsAll = async (keyword: string) => {
    // const result = await searchProgressStatus(keyword);
    // setEmployees(result?.data);
  };

  useEffect(() => {
    if (searchKeywords.length > 2) {
      searchGroupsAll(searchKeywords);
    }
    if (searchKeywords.length === 0) {
      //   getEmployeeData();
    }
  }, [searchKeywords]);

  const [empFilter, setEmpFilter] = useState({} as any);

  const onSubmit = (data: any) => {
    // filterProgressStatus(data).then((res) => {
    //   setEmployees((res.data as any[]) || []);
    // });
  };

  const resetFilterResult = () => {
    reset();
    setEmpFilter(initialProjectFilterValues);
    // getEmployeeData();
  };

  useEffect(() => {
    const isNullish = Object.values(empFilter).every((value) => {
      if (value === null) {
        return true;
      }

      return false;
    });

    if (Object.keys(empFilter).length === 0 || isNullish) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [empFilter]);

  const CardHeaderWrapper = styled(CardHeader)(
    () => `
            .MuiCardHeader-action{
              width: 100%
            }
          `
  );

  const CustomTableRow = withStyles({
    root: {
      background: '#E6E9FF !important',
      height: '3.5rem'
    }
  })(TableRow);

  function LinearProgressWithLabel(
    props: LinearProgressProps & { value: number }
  ) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '4rem', mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body2" color="text.secondary">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Fragment>
      <PageTitleWrapper>
        <Grid container alignItems="center" direction={'row'}>
          <Grid item>
            <Typography
              onClick={() => {
                navigate('/dashboard');
              }}
              style={{ cursor: 'pointer' }}
              variant="h4"
              component="h4"
            >
              {' '}
              Dashboard /&nbsp;
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              style={{ fontWeight: 'normal' }}
              variant="h4"
              component="h4"
            >
              Total Resource Allocation
            </Typography>
          </Grid>
          <Grid
            item
            display="flex"
            justifyContent="flex-end"
            style={{ marginLeft: 'auto' }}
          >
            <Button
              sx={{
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              startIcon={<GetAppIcon fontSize="small" />}
              style={{ height: '1.75rem' }}
              // onClick={handleClickOpen}
            >
              Download Report
            </Button>
          </Grid>
        </Grid>
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Card>
          <Grid
            container
            style={{
              justifyContent: 'space-between',
              padding: '1rem 1rem 0rem 1rem'
            }}
            spacing={2}
          >
            <Grid item xs={6}>
              <TextField
                sx={{ width: 150, mr: 2 }}
                size="small"
                placeholder="Search..."
                onChange={(e) => nameChange(e)}
                InputProps={{
                  style: { fontSize: '12px', height: '1.75rem' },
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon
                        sx={{ color: '#d3d3d3' }}
                        style={{ fontSize: '15px' }}
                      />
                    </InputAdornment>
                  )
                }}
              />
              <Button
                sx={{
                  mt: { xs: 2, md: 0 },
                  color: `${!toggleFilter && 'gray'}`
                }}
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={() => {
                  setToggleFilter(!toggleFilter);
                }}
                style={{ height: '1.75rem', fontSize: '12px' }}
              >
                Filters
              </Button>
            </Grid>
          </Grid>
          <CardHeaderWrapper
            action={
              <>
                <form onSubmit={handleSubmit(onSubmit)}>
                  {toggleFilter ? (
                    <>
                      <Grid
                        container
                        sx={{ pr: 2 }}
                        spacing={2}
                        style={{
                          paddingTop: 3,
                          paddingBottom: 2,
                          justifyContent: 'flex-start'
                        }}
                      >
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Employee Name
                            </InputLabel>
                            <Select
                              sx={{ mt: 1 }}
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              autoWidth
                              size="small"
                              {...register('name')}
                              value={empFilter.name}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  name: e.target.value
                                }));
                                setValue('name', e.target.value);
                              }}
                            >
                              {/* {(clientNames || []).map((item, i) => {
                                return (
                                  <MenuItem value={item} key={i}>
                                    {item}
                                  </MenuItem>
                                );
                              })} */}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Project
                            </InputLabel>
                            <Select
                              sx={{ mt: 1 }}
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              autoWidth
                              size="small"
                              value={empFilter.project}
                              {...register('project')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  project: e.target.value
                                }));
                                setValue('project', e.target.value);
                              }}
                            >
                              {/* {(tracks || []).map((item, i) => {
                                return (
                                  <MenuItem value={item.code} key={i}>
                                    {item.code}
                                  </MenuItem>
                                );
                              })} */}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Project Status
                            </InputLabel>
                            <Select
                              className="select-text"
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              sx={{ mt: 1 }}
                              autoWidth
                              size="small"
                              value={empFilter.status}
                              {...register('status')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  status: e.target.value
                                }));
                                setValue('status', e.target.value);
                              }}
                            >
                              {/* {(projectStatus || []).map((item, i) => {
                                return (
                                  <MenuItem value={item.name} key={i}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })} */}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <InputLabel
                              style={{
                                fontSize: '12px'
                              }}
                            >
                              Project Role
                            </InputLabel>
                            <Select
                              className="select-text"
                              style={{
                                fontSize: '12px',
                                height: '2rem'
                              }}
                              sx={{ mt: 1 }}
                              autoWidth
                              size="small"
                              value={empFilter.role}
                              {...register('role')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  role: e.target.value
                                }));
                                setValue('role', e.target.value);
                              }}
                            >
                              <MenuItem value="Approved">Approved</MenuItem>
                              <MenuItem value="Raised">Raised</MenuItem>
                              <MenuItem value="Not raised">Not raised</MenuItem>
                              <MenuItem value="N/A">N/A</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <TextField
                              InputProps={{
                                style: { fontSize: '12px', height: '2rem' }
                              }}
                              sx={{ mt: 1 }}
                              style={{
                                fontSize: '12px',
                                height: '1.5rem'
                              }}
                              size="small"
                              type="date"
                              placeholder="DD/MM/YYYY"
                              value={moment(empFilter.startDate).format(
                                'YYYY-MM-DD'
                              )}
                              {...register('startDate')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  startDate: e.target.value
                                }));
                                setValue('startDate', e.target.value);
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                          <FormControl fullWidth>
                            <TextField
                              InputProps={{
                                style: { fontSize: '12px', height: '2rem' }
                              }}
                              sx={{ mt: 1 }}
                              style={{
                                fontSize: '12px',
                                height: '1.5rem'
                              }}
                              size="small"
                              type="date"
                              placeholder="DD/MM/YYYY"
                              value={moment(empFilter.endDate).format(
                                'YYYY-MM-DD'
                              )}
                              {...register('endDate')}
                              onChange={(e) => {
                                setEmpFilter((prev) => ({
                                  ...prev,
                                  endDate: e.target.value
                                }));
                                setValue('endDate', e.target.value);
                              }}
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Grid
                        sx={{ pr: 2 }}
                        container
                        style={{ justifyContent: 'flex-end', marginTop: 4 }}
                        xs={12}
                      >
                        <Button
                          sx={{ mt: { xs: 2, md: 0 }, mr: 2 }}
                          variant="text"
                          onClick={resetFilterResult}
                          disabled={isDisabled}
                          style={{ height: '1.75rem', fontSize: '12px' }}
                        >
                          Clear
                        </Button>
                        <Button
                          sx={{ mt: { xs: 2, md: 0 } }}
                          disabled={isDisabled}
                          variant="outlined"
                          type="submit"
                          style={{ height: '1.75rem', fontSize: '12px' }}
                        >
                          Filter
                        </Button>
                      </Grid>
                    </>
                  ) : (
                    <></>
                  )}
                </form>
              </>
            }
            title=""
          />
          <TableContainer className="tableContainer hideScroll">
            <Table size="small">
              <TableHead>
                <CustomTableRow>
                  <TableHeaderCell content="Employee Name" smallFont />
                  <TableHeaderCell content="Designation" smallFont />
                  <TableHeaderCell content="Project" smallFont />
                  <TableHeaderCell content="Project Role" smallFont />
                  <TableHeaderCell content="Project Role ID" smallFont />
                  <TableHeaderCell content="Resource Type" smallFont />
                  <TableHeaderCell content="Allocation" smallFont />
                  <TableHeaderCell content="Start Date" smallFont />
                  <TableHeaderCell content="End Date" smallFont />
                </CustomTableRow>
              </TableHead>
              <TableBody>
                {paginatedEmployees &&
                  paginatedEmployees?.length > 0 &&
                  paginatedEmployees.map((listItem) => {
                    return (
                      <TableRow hover>
                        <TableColumnCell>
                          <Typography
                            paddingBottom="1rem"
                            style={{ fontSize: '11px' }}
                            variant="body2"
                            gutterBottom
                            noWrap
                          >
                            {listItem.name}
                          </Typography>
                        </TableColumnCell>
                        <TableColumnCell>
                          <Typography
                            paddingBottom="1rem"
                            style={{ fontSize: '11px' }}
                            variant="body2"
                            gutterBottom
                            noWrap
                          >
                            {listItem.designation}
                          </Typography>
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.allocations.map((item) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {item.projectName}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.allocations.map((item) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {item.role || '-'}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.allocations.map((item) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {item.roleId || '-'}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.allocations.map((item) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {item.type || '-'}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.allocations.map((item) => (
                            <LinearProgressWithLabel
                              variant="determinate"
                              value={
                                item.allocation >= 100 ? 100 : item.allocation
                              }
                              color={
                                item.allocation >= 100 ? 'error' : 'primary'
                              }
                            />
                            // <Typography
                            //   paddingBottom="1rem"
                            //   style={{ fontSize: '11px' }}
                            //   variant="body2"
                            //   gutterBottom
                            //   noWrap
                            // >
                            //   {item.allocation || '-'}
                            // </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.allocations.map((item) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {moment(item?.startDate).format('MM/DD/YYYY')}
                            </Typography>
                          ))}
                        </TableColumnCell>
                        <TableColumnCell>
                          {listItem?.allocations.map((item) => (
                            <Typography
                              paddingBottom="1rem"
                              style={{ fontSize: '11px' }}
                              variant="body2"
                              gutterBottom
                              noWrap
                            >
                              {moment(item?.endDate).format('MM/DD/YYYY')}
                            </Typography>
                          ))}
                        </TableColumnCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          {/* {paginatedweeklyProjectWork?.length === 0 && (
          <Typography
            style={{
              fontSize: '15px',
              fontWeight: 'bold',
              margin: '1rem',
              textAlign: 'center'
            }}
            variant="body2"
          >
            No Records Found
          </Typography>
        )} */}
        </Card>
      </Container>
    </Fragment>
  );
};

export default TotalResourceAllocation;
